export const getSelfEmployedParam = isSelfEmployed => isSelfEmployed ? 'true' : 'false';
